import { render } from "./QuoterNav.vue?vue&type=template&id=cb4dd62e&scoped=true"
import script from "./QuoterNav.vue?vue&type=script&lang=js"
export * from "./QuoterNav.vue?vue&type=script&lang=js"

import "./QuoterNav.vue?vue&type=style&index=0&id=cb4dd62e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb4dd62e"]])

export default __exports__